import React, { useContext, useEffect, useState } from 'react';
import { Widget, Table, Button, ButtonDelete, CrudContext } from '@digital/ui';
import ComponeteCurso from '../../../components/componeteCurso';

import { Icon, Tooltip, Collapse, Modal } from 'antd';
import {
  ArquivosIniciaisDocontrato,
  getAllArquivosIniciaisDoContrato,
  excluirAquivoInicialDoContrato,
  GetAquivoInicialDoContrato,
  ViewArquivoInicialDoContrato,
  substituirArquivoInicialDoContrato,
} from '../../../api/contrato';
import { hasPermission } from '@app/helpers/permissions';
import { GetFileExtension, imageFormats } from '@app/helpers';

interface PropArquivoOriginalContrato {
  contratoId: string;
}

const ArquivoOriginalContrato = (props: PropArquivoOriginalContrato) => {
  const { Panel } = Collapse;
  const { contratoId } = props;
  const { selectedItem } = useContext(CrudContext);

  const [data, setData] = useState<ArquivosIniciaisDocontrato[]>();
  const [arquivoParaSubstituir, setArquivoParaSubstituir] = useState<ArquivosIniciaisDocontrato | null>(null);
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);

  const abrirModalSubstituir = (record: ArquivosIniciaisDocontrato) => {
    setArquivoParaSubstituir(record);
    setArquivoSelecionado(null);
  };

  const fecharModalSubstituir = () => {
    setArquivoParaSubstituir(null);
    setArquivoSelecionado(null);
  };

  const confirmarSubstituicao = async () => {
    if (arquivoParaSubstituir && arquivoSelecionado) {
      const result = await substituirArquivoInicialDoContrato(arquivoParaSubstituir.id, arquivoSelecionado);
      if (result) {
        fecharModalSubstituir();
        getData();
      }
    }
  };

  useEffect(() => {
    getData();
  }, [selectedItem]);

  const getData = async () => {
    if (selectedItem) {
      const result = await getAllArquivosIniciaisDoContrato(selectedItem.id);
      if (result) setData(result);
    }
  };

  const excluirArquivo = async (arquivoInicialId: string) => {
    const result = await excluirAquivoInicialDoContrato(arquivoInicialId);
    if (result) {
      if (result.valid === true) {
        getData();
      }
    }
  };

  const baixarArquivo = (arquivoInicialId: string, nomeDoArquivo: string) => {
    const result = GetAquivoInicialDoContrato(arquivoInicialId, nomeDoArquivo);
  };

  const viewArquivo = (arquivoInicialId: string, nomeDoArquivo: string) => {
    const result = ViewArquivoInicialDoContrato(arquivoInicialId, nomeDoArquivo);
  };

  const columns = [
    {
      title: 'Número',
      dataIndex: 'numero',
      width: '5%',
    },
    {
      title: 'Nome',
      dataIndex: 'nome',
      width: '20%',
    },
    {
      title: 'Inclusão',
      dataIndex: 'inclusao',
      width: '20%',
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      width: '20%',
    },
    {
      title: 'Ações',
      dataIndex: '',
      key: 'x',
      width: '5%',
      render: record => (
        <>
          {hasPermission(['CONTRATO_GERAL_ANEXOS_CONTRATO_ADITIVOS']) ? (
            <>
              <>
                <Tooltip title="Deletar Item">
                  <ButtonDelete
                    onClick={() => {
                      excluirArquivo(record.id);
                    }}
                    name="btnExcluirItem"
                    icon="science-minus"
                    confirm="Deseja realmente excluir este registro?"
                    okText="Confirmar"
                    className="btn-delete-without-text"
                  />
                </Tooltip>
                <Tooltip title="Baixar Arquivo">
                  <Button
                    onClick={() => {
                      baixarArquivo(record.id, record.nome);
                    }}
                    icon="ui-download"
                    name="btnBaixarArquivo"
                  />
                </Tooltip>
                <Tooltip title="Substituir Arquivo">
                  <Button
                    onClick={() => {
                      abrirModalSubstituir(record);
                    }}
                    icon="ui-upload"
                    name="btnSubstituirArquivo"
                  />
                </Tooltip>

                {GetFileExtension(record.nome) === 'pdf' || imageFormats.includes(GetFileExtension(record.nome)) ? (
                  <Tooltip title="Visualizar Arquivo">
                    <Button
                      onClick={async () => {
                        await viewArquivo(record.id, record.nome);
                      }}
                      icon="files-view_file"
                      name="btnViewArquivo"
                    />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </>
            </>
          ) : (
            <>
              <>
                <Tooltip title="Baixar Arquivo">
                  <Button
                    onClick={() => {
                      baixarArquivo(record.id, record.nome);
                    }}
                    icon="ui-download"
                    name="btnBaixarArquivo"
                  />
                </Tooltip>
                {GetFileExtension(record.nome) === 'pdf' || imageFormats.includes(GetFileExtension(record.nome)) ? (
                  <Tooltip title="Visualizar Arquivo">
                    <Button
                      onClick={async () => {
                        await viewArquivo(record.id, record.nome);
                      }}
                      icon="files-view_file"
                      name="btnViewArquivo"
                    />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </>
            </>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="arquivosdoContrato" header={'Arquivos do Contrato'} style={{ border: 0 }}>
          <Widget>
            {hasPermission(['CONTRATO_GERAL_ANEXOS_CONTRATO_ADITIVOS']) ? (
              <>
                <ComponeteCurso
                  id={selectedItem.id}
                  nomeIdFormulario={'ContratoId'}
                  enderecoApi={'contratos/updateArquivoContratoInicialCommand'}
                  descricaoBotao={'Incluir Arquivo'}
                  retorno={data => {
                    if (data.valid) {
                      getData();
                    }
                  }}
                  idDoComponente="updateArquivoContratoInicial"
                />
              </>
            ) : (
              <> </>
            )}
            <br />
            <br />
            <Table rowKey="rowId" columns={columns} dataSource={data} pagination={false} />
          </Widget>
        </Panel>
      </Collapse>
      <Modal
        title="Substituir Arquivo"
        visible={arquivoParaSubstituir !== null}
        onCancel={fecharModalSubstituir}
        footer={[
          <Button key="cancelar" onClick={fecharModalSubstituir}>
            Cancelar
          </Button>,
          <Button
            key="substituir"
            type="primary"
            disabled={!arquivoSelecionado}
            onClick={confirmarSubstituicao}
            name="btnConfirmarSubstituir">
            Substituir
          </Button>,
        ]}>
        {arquivoParaSubstituir && (
          <>
            <p>
              Arquivo atual: <strong>{arquivoParaSubstituir.nome}</strong>
            </p>
            <input
              type="file"
              name="inputSubstituirArquivo"
              onChange={e => {
                setArquivoSelecionado(e.target.files && e.target.files.length > 0 ? e.target.files[0] : null);
              }}
            />
          </>
        )}
      </Modal>
    </>
  );
};

export default ArquivoOriginalContrato;
